export class BaseClaims {

    public static ImportExcel: string = "ImportExcel";
    public static ExportExcel: string = "ExportExcel";
    
    public static ManageBranches: string = "ManageBranches";
    public static ManageUsers: string = "ManageUsers";
    public static Dashboard: string = "Dashboard";

    // Users
    public static CanAddUsers: string = "CanAddUsers";
    public static CanDeleteUsers: string = "CanDeleteUsers";
    public static CanUpdateUsers: string = "CanUpdateUsers";
    public static CanViewUserLoginHistory: string = "CanViewUserLoginHistory";

    // Permissions
    public static CanAccessPermissions: string = "CanAccessPermissions";
    public static CanAccessValidations: string = "CanAccessValidations";
    public static CanUpdatePermissions: string = "CanUpdatePermissions";

    // Lookups
    public static CanAccessManageLookups: string = "CanAccessManageLookups";
    public static CanAddLookups: string = "CanAddLookups";
    public static CanDeleteLookups: string = "CanDeleteLookups";
    public static CanUpdateLookups: string = "CanUpdateLookups";
    public static UpdateLookupsGlobally: string = "UpdateLookupsGlobally";

    public static AcceptCalls: string = "AcceptCalls";

    public static GetClientForms: string = "GetClientForms";
    public static UpdateClientForms: string = "UpdateClientForms";
    public static AddNewClientForm: string = "AddNewClientForm";
    public static DeleteClientForm: string = "DeleteClientForms";
    public static CloneClientForms: string = "CloneClientForms";
    public static ChangeCloneInternalName: string= "ChangeCloneInternalName";

    public static EquitiesClientConfig: string = "EquitiesClientConfig";
    public static WorkflowsConfig: string = "WorkflowsConfig";
    public static CreateWorkflowConfiguration: string = "CreateWorkflowConfiguration";
    public static CanTakeOwnership: string = "CanTakeOwnership";
    public static CanReassign: string = "CanReassign";
    public static CanReassignOfAny: string = "CanReassignOfAny";

    public static ViewStatusReasonTransitions: string = "ViewStatusReasonTransitions";
    public static ManageStatusReasonTransitions: string = "ManageStatusReasonTransitions";

    public static CanAccessManageEntities: string = "CanAccessManageEntities";

    public static ShareGlobally: string = "ShareGlobally";
    public static EditDashboard: string = "EditDashboard";
    public static AssignDashboards: string = "AssignDashboards";
    public static ManageDashboards: string = "ManageDashboards";
    public static ShowAdmin: string = "ShowAdmin";

    //Gdpr
    public static PolicyManagement: string = "PolicyManagement";
    public static PersonalDataManagement: string = "PersonalDataManagement";
    public static AddPersonalDataRecord: string = "AddPersonalDataRecord";
    public static UpdatePersonalDataRecord: string = "UpdatePersonalDataRecord";
    public static DeletePersonalDataRecord: string = "DeletePersonalDataRecord";
    public static ManageCases: string = "ManageCases";
    public static AddNewGdprCase: string = "AddNewGdprCase";
    public static UpdateGdprCase: string = "UpdateGdprCase";
    public static DeleteGdprCase: string = "DeleteGdprCase";
    public static DataSubjects: string = "DataSubjects";
    public static AddNewGdprDataSubject: string = "AddNewGdprDataSubject";
    public static UpdateNewGdprDataSubject: string = "UpdateNewGdprDataSubject";
    public static DeleteNewGdprDataSubject: string = "DeleteNewGdprDataSubject";

    //Attachment
    public static GetAttachments: string = "GetAttachments";
    public static AddEntityAttachments: string = "AddEntityAttachments";
    public static UpdateEntityAttachments: string = "UpdateEntityAttachments";
    public static RemoveEntityAttachments: string = "RemoveEntityAttachments";

    //Queries
    public static EditSharedQueries: string = "EditSharedQueries";
    public static DeleteSharedQueries: string = "DeleteSharedQueries";
    public static AssignQueries: string = "AssignQueries";

    //Version
    public static AddVersions: string = "AddVersions";
    public static UpdateVersions: string = "UpdateVersions";
    public static DeleteVersions: string = "DeleteVersions";
    public static ViewVersions: string = "ViewVersions";

    //Scheduled Maintenance
    public static AddScheduledMaintenances: string = "AddScheduledMaintenances";
    public static UpdateScheduledMaintenances: string = "UpdateScheduledMaintenances";
    public static DeleteScheduledMaintenances: string = "DeleteScheduledMaintenances";
    public static ViewScheduledMaintenances: string = "ViewScheduledMaintenances";
    public static CompleteScheduledMaintenances: string = "CompleteScheduledMaintenances";

    //ManageQueries
    public static ManageQueries: string = "ManageQueries";
    
    //Emails
    public static ApproveEmail: string = "ApproveEmail";
    public static RejectEmail: string = "RejectEmail";
    public static EditEmail: string = "EditEmail";
    public static ResendEmail: string = "ResendEmail";
}

